import paymentStore from 'Models/PaymentStore';

export function NumberToCorrectCurrency() {
	const { currencyCode, currencyLocale } = paymentStore;
	return new Intl.NumberFormat(currencyLocale, { style: 'currency', currency: currencyCode });
}

export function formatCurrency(value: number) {
	return NumberToCorrectCurrency().format(value);
}

export function formatCurrencyWithNoSymbol(value: number) {
	const currencyWithSymbol = formatCurrency(value);
	return currencyWithSymbol.replace(getDefaultCurrencySymbol(), '');
}

export function roundToTwoDecimals(value: number) {
	return Math.round(value * 100) / 100;
}

export const getDefaultCurrencySymbol = () => {
	const { currencyCode, currencyLocale } = paymentStore;

	const formatter = new Intl.NumberFormat(currencyLocale, {
		style: 'currency',
		currency: currencyCode,
	});

	let symbol;
	formatter.formatToParts(0).forEach(({ type, value }) => {
		if (type === 'currency') {
			symbol = value;
		}
	});

	return symbol ?? '';
};
